import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { RefreshCw, AlertCircle, ArrowUpDown, ArrowUp, ArrowDown , Wallet, Receipt, Calculator , LogOut , Menu} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getMaoDeObra,getTodosDados  } from '../api';

import MultiSelect from '../componets/MultiSelect';
import {
  
  PROJETOS_TABELA_NORMAL,
  FATURAMENTO_2026,
  MAPA_MESES_2025,

} from "../constants/projetos";

import { logout } from '../utils/auth';


const Dashboard = () => {
  const parseBRL = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === 'number') return value;

    const str = String(value).trim();
    if (!str) return 0;

    let limpo = str.replace(/[^\d.,-]/g, '');

    const ultimaVirgula = limpo.lastIndexOf(',');
    const ultimoPonto = limpo.lastIndexOf('.');

    if (ultimaVirgula > ultimoPonto) {
      limpo = limpo
        .replace(/\./g, '')
        .replace(',', '.');
    } 
    else if (ultimoPonto > ultimaVirgula) {
      limpo = limpo.replace(/,/g, '');
    }
    else if (ultimaVirgula !== -1) {
      limpo = limpo.replace(',', '.');
    }

    const numero = Number(limpo);
    return isNaN(numero) ? 0 : numero;
  };

  const MESES_DRE = [
    { value: 'Todos', label: 'Todos' },
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' },
  ];
  const [filters, setFilters] = useState({
    projeto: [],
    prestador: [],
    gerente: [],
    dataDre: [],
    anoDre: [],
    margemProjetada: [],
  });

  // Estado para controlar a ordenação
  const [ordenacao, setOrdenacao] = useState({
    campo: null,
    direcao: 'asc'
  });

  const [dadosOriginais, setDadosOriginais] = useState([]);
  const [dadosLancamentos, setDadosLancamentos] = useState([]);
  const [dadosLancamentos2025, setDadosLancamentos2025] = useState([]);
  const [dadosCompetencia, setDadosCompetencia] = useState([]);
  const [dadosMaoDeObra, setDadosMaoDeObra] = useState([]);
  const [open , setOpen] = useState([])
  const [linhasExpandidas, setLinhasExpandidas] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    carregarDadosGoogleSheets();
  }, []);

  const carregarDadosGoogleSheets = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const [result, resultMaoDeObra] = await Promise.all([
        getTodosDados(),
        getMaoDeObra(),
      ]);
            

      if (!result.success) {
        throw new Error(result.error || 'Erro desconhecido ao buscar dados');
      }
      const dadosLanc = result.lancamentos.data.map(item => {
        const dataCompleta = item['Data (completa)'] || '';
        let mes = null;
        let ano = null;

        if (dataCompleta) {
          const partes = dataCompleta.split('/');
          if (partes.length === 3) {
            mes = Number(partes[1]);
            ano = Number(partes[2]);
          }
        }

        return {
          empresa: item['Minha Empresa (Razão Social)'] || 'N/A',
          projeto: item['Projeto'] || 'N/A',
          valor: parseBRL(item['Valor'] || 0),
          departamento: item['Departamento'],
          data: dataCompleta,
          mes: mes,
          ano: ano
        };
      });
      const dadosNFe = result.nfe.data.map(item => ({

        projeto: item['Nome do Projeto'] || 'N/A',
        prestador: item['Prestador de serviço'] || 'N/A',
        gerente: item['Gerente de Projeto'] || 'N/A',
        valorBruto: (item['Valor Bruto'] || 0),
        margemBruta: (item['Margem Bruta do Contrato']) || 0,
        faturamentoLiquido: (item['Faturamento Liquido']) || 0,
        dataDre: Number(item['Mês DRE']) || null,
        anoDre: Number(item['Ano DRE']) || null,
        margemProjetada: item['Margem Bruta do Contrato'] || ''
      }));

      
      console.log('dadosNFe :>> ', dadosNFe);
      const dadosLancc2025 = result.lancamentos2025.data.map(item => {
        const mesTexto = item['Mês'] || '';
        const mesNumerico = MAPA_MESES_2025[mesTexto] || null;

        return {
          mes: mesNumerico,
          gerente: item['Gerente de Projetos'] || 'N/A',
          projeto: item['Nomes Projetos Oficiais'] || 'N/A',
          maoDeObra: parseBRL(item['Mão de Obra'] || 0),
          outrosCustos: parseBRL(item['Outros Custos (Viagem, freelance etc)'] || 0),
          outrosCustosRateio: parseBRL(item['Outros Custos Rateio'] || 0),
          valorBruto: parseBRL(item['Faturamento Bruto'] || 0),
          margemBrutaReal: parseBRL(item['Margem Bruta'] || 0),
          faturamentoLiquido: parseBRL(item['Receita Líquida'] || 0),
          anoDre: 2025,
        };
      });
      const dadosComp = (result.competencia?.data || []).map(item => {
        const compStr = item['Competência'] || '';
        const partes = compStr.split('/');
        const mesComp = partes.length === 2 ? Number(partes[0]) : null;
        const anoComp = partes.length === 2 ? Number(partes[1]) : null;

        return {
          projeto: item['Projeto'] || 'N/A',
          saldoBruto: parseBRL(item['Saldo Bruto'] || 0),
          saldoLiquido: parseBRL(item['Saldo Liquido'] || 0),
          mes: mesComp,
          ano: anoComp,
        };
      });

      setDadosCompetencia(dadosComp);
      setDadosOriginais(dadosNFe);
      setDadosLancamentos(dadosLanc);
      setDadosLancamentos2025(dadosLancc2025)

      // Processa dados do endpoint /api/dados-mao-de-obra
      // .trim() é essencial: nomes na planilha chegam com espaços extras ex: " NEOXS - PREDI "
      if (resultMaoDeObra?.success && Array.isArray(resultMaoDeObra.data)) {
        const maoDeObraProcessada = resultMaoDeObra.data.map(item => {
          const mesStr = (item['mês'] || '').trim();
          const partes = mesStr.split('/');
          const mes = partes.length === 2 ? Number(partes[0]) : null;
          const ano = partes.length === 2 ? Number(partes[1]) : null;
          return {
            projeto: (item['PROJETO'] || 'N/A').trim(),
            valor: Number(item['Valor']) || 0,
            mes,
            ano,
          };
        });
        setDadosMaoDeObra(maoDeObraProcessada);
      }
      setLoading(false);

    } catch (err) {
      console.error('❌ Erro ao carregar dados:', err);
      setError(err.message);
      setLoading(false);
    }
  };

  const projetos = ['Todos', ...new Set(dadosOriginais.map(d => d.projeto))].sort();
  const prestadores = ['Todos', ...new Set(dadosOriginais.map(d => d.prestador))];
  const gerentes = ['Todos', ...new Set(dadosOriginais.map(d => d.gerente))];
  const anos = [2025,2026];
  const is2025 = filters.anoDre.length === 1 && filters.anoDre[0] === 2025;

 const projetosSet = is2025
  ? new Set(dadosLancamentos2025.map(d => d.projeto)) // projetos novos só 2025
  : new Set(dadosOriginais.map(d => d.projeto));      // projetos históricos

const projetosOptions = [...projetosSet]
  .sort()
  .map(p => ({ value: p, label: p }));


  const prestadoresOptions = prestadores
    .filter(p => p !== 'Todos')
    .map(p => ({ value: p, label: p }));

  const gerentesOptions = gerentes
    .filter(g => g !== 'Todos')
    .map(g => ({ value: g, label: g }));

  const anosOptions = anos
    .filter(a => a !== 'Todos')
    .map(a => ({ value: a, label: a }));

  const mesesOptions = MESES_DRE
    .filter(m => m.value !== 'Todos')
    .map(m => ({ value: m.value, label: m.label }));


  let dadosFiltrados = [];


  if (is2025) {
    // usa só dados do Lancc 2025
    dadosFiltrados = dadosLancamentos2025.filter(item => {
      return (
        (filters.projeto.length === 0 || filters.projeto.includes(item.projeto)) &&
        (filters.gerente.length === 0 || filters.gerente.includes(item.gerente)) &&
        (filters.dataDre.length === 0 || filters.dataDre.includes(item.mes))
      );      
    });
  } else {
    // comportamento antigo
      dadosFiltrados = dadosOriginais.filter(item => {
        if (item.anoDre === null || item.anoDre === '' || item.anoDre === 2024) {
          return false;
        }

        return (
          (filters.projeto.length === 0 || filters.projeto.includes(item.projeto)) &&
          (filters.prestador.length === 0 || filters.prestador.includes(item.prestador)) &&
          (filters.gerente.length === 0 || filters.gerente.includes(item.gerente)) &&
          (filters.dataDre.length === 0 || filters.dataDre.includes(item.dataDre)) &&
          (filters.anoDre.length === 0 || filters.anoDre.includes(item.anoDre))
        );
      });

  }
  const dadosLancFiltrados = dadosLancamentos.filter(item => {
    if (item.ano === null || item.ano === '' || item.ano === 2024) {
      return false;
    }
    if (item.departamento !== 'OPERAÇÃO'){
      return false;
    }

    return (
      (filters.projeto.length === 0 || filters.projeto.includes(item.projeto)) &&
      (filters.dataDre.length === 0 || filters.dataDre.includes(item.mes)) &&
      (filters.anoDre.length === 0 || filters.anoDre.includes(item.ano))
    );
  });
  const custosOperacionaisPorProjeto = dadosLancFiltrados.reduce((acc, item) => {
    if (!acc[item.projeto]) {
      acc[item.projeto] = 0;
    }
    acc[item.projeto] += Number(item.valor) || 0;
    return acc;
  }, {});

  // Agrega custo de mão de obra por projeto respeitando os filtros de mês e ano
  // Nomes já chegam normalizados com .trim() no processamento do estado
  const custosMaoDeObraPorProjeto = dadosMaoDeObra
    .filter(item => {
      return (
        (filters.dataDre.length === 0 || filters.dataDre.includes(item.mes)) &&
        (filters.anoDre.length === 0 || filters.anoDre.includes(item.ano))
      );
    })
    .reduce((acc, item) => {
      acc[item.projeto] = (acc[item.projeto] || 0) + item.valor;
      return acc;
    }, {});



let dadosAgrupados = [];

  if (is2025) {
    const agrupado = {};

    dadosFiltrados.forEach(item => {
      if (!agrupado[item.projeto]) {
        agrupado[item.projeto] = {
          projeto: item.projeto,
          gerente: item.gerente,
          anoDre: 2025,
          valorBruto: 0,
          faturamentoLiquido: 0,
          maoDeObra: 0,
          outrosCustos: 0,
          outrosCustosRateio: 0,
          margemBrutaPercentual: 0,
          margemProjetada:item.margemProjetada,
          detalhes: []
        };
      }

      agrupado[item.projeto].valorBruto += item.valorBruto;
      agrupado[item.projeto].faturamentoLiquido += item.faturamentoLiquido;
      agrupado[item.projeto].maoDeObra += item.maoDeObra;
      agrupado[item.projeto].outrosCustos += item.outrosCustos;
      agrupado[item.projeto].outrosCustosRateio += item.outrosCustosRateio;
      agrupado[item.projeto].margemBrutaPercentual += item.margemBrutaPercentual;

      agrupado[item.projeto].detalhes.push(item);
    });

    dadosAgrupados = Object.values(agrupado);
  }else {

  // comportamento original
  dadosAgrupados = dadosFiltrados.reduce((acc, item) => {
    const projetoExistente = acc.find(p => p.projeto === item.projeto);
    
    if (projetoExistente) {
      projetoExistente.margemBruta += item.margemBruta;
      projetoExistente.faturamentoLiquido += item.faturamentoLiquido;
      projetoExistente.valorBruto += item.valorBruto;
    } else {
      acc.push({
        projeto: item.projeto,
        gerente: item.gerente,
        prestador: item.prestador,
        dataDre: item.dataDre,
        anoDre: item.anoDre,
        margemBruta: item.margemBruta,
        faturamentoLiquido: item.faturamentoLiquido,
        valorBruto: item.valorBruto,
        margemProjetada: item.margemProjetada
      });
    }
    
    return acc;
  }, []);
}
  const dadosTabela2025 = dadosAgrupados.map(item => {
      // Garantir que valores sejam números válidos
      const valorBruto = Number(item.valorBruto) || 0;
      const faturamentoLiquido = Number(item.faturamentoLiquido) || 0;
      const outrosCustos = Number(item.outrosCustos) || 0;
      const outrosCustosRateio = Number(item.outrosCustosRateio) || 0;
      const maoDeObra = Number(item.maoDeObra) || 0;
      // Cálculos intermediários
      const custoOperacional = outrosCustos + outrosCustosRateio;
      const margemBrutaReal = faturamentoLiquido - custoOperacional - maoDeObra;
      // Cálculo de percentuais (com tratamento de divisão por zero)
      const calcularPercentual = (valor, base) => {
          if (!base || base === 0) return 0;
          return ((valor / base) * 100).toFixed(2);
      };
      
      return {
          projeto: item.projeto,
          gerente: item.gerente,
          valorBruto: valorBruto,
          faturamentoLiquido: faturamentoLiquido,
          custoOperacional: custoOperacional,
          percentualCustoOp: calcularPercentual(custoOperacional, faturamentoLiquido),
          custoMaoDeObra: maoDeObra,
          percentualMaoDeObra: calcularPercentual(maoDeObra, faturamentoLiquido),
          margemBrutaReal: margemBrutaReal,
          percentualMargemBruta: calcularPercentual(margemBrutaReal, faturamentoLiquido),
          detalhes: item.detalhes
      };
  });

// Agrega competência por projeto respeitando os filtros ativos
const faturamentoCompetenciaPorProjeto = dadosCompetencia
  .filter(item => {
    if (!item.ano || item.ano < 2026) return false;
    return (
      (filters.projeto.length === 0 || filters.projeto.includes(item.projeto)) &&
      (filters.dataDre.length === 0 || filters.dataDre.includes(item.mes)) &&
      (filters.anoDre.length === 0 || filters.anoDre.includes(item.ano))
    );
  })
  .reduce((acc, item) => {
    if (!acc[item.projeto]) {
      acc[item.projeto] = { valorBruto: 0, faturamentoLiquido: 0 };
    }
    acc[item.projeto].valorBruto   += item.saldoBruto;
    acc[item.projeto].faturamentoLiquido += item.saldoLiquido;
    return acc;
  }, {});
  
  const dadosTabelaNormal = PROJETOS_TABELA_NORMAL.map(projeto => {
  const item = dadosAgrupados.find(d => d.projeto === projeto);

  let faturamentoLiquido = Number(item?.faturamentoLiquido) || 0;
  let valorBruto = Number(item?.valorBruto) || 0;

  valorBruto += faturamentoCompetenciaPorProjeto[projeto]?.valorBruto || 0;
  faturamentoLiquido += faturamentoCompetenciaPorProjeto[projeto]?.faturamentoLiquido || 0;
  
  const custoOperacional =
    (custosOperacionaisPorProjeto[projeto] * -1) || 0;

    let custoMaoDeObra = 0;

    custoMaoDeObra = custosMaoDeObraPorProjeto[projeto] || 0;
  
    const margemBrutaReal =
      faturamentoLiquido - custoMaoDeObra - custoOperacional;

  const calcularPercentual = (valor, base) =>
    base > 0 ? ((valor / base) * 100).toFixed(2) : "0.00";

  return {
    projeto,
    gerente: item?.gerente || "-",
    valorBruto,
    faturamentoLiquido,
    custoOperacional,
    percentualCustoOp: calcularPercentual(custoOperacional, faturamentoLiquido),
    custoMaoDeObra,
    percentualMaoDeObra: calcularPercentual(custoMaoDeObra, faturamentoLiquido),
    margemBrutaReal,
    percentualMargemBruta: calcularPercentual(margemBrutaReal, faturamentoLiquido),
    margemProjetada: item?.margemProjetada || "-"

  };
});


// ─── RATEIO DE OPERAÇÕES ────────────────────────────────────────────────────
// Distribui proporcionalmente (por faturamentoLiquido) o custoOperacional do
// projeto "RATEIO DE OPERAÇÕES" entre todos os demais e o remove da tabela.
const NOME_RATEIO = 'RATEIO DE OPERAÇÕES';

const dadosTabelaNormalComRateio = (() => {
  const projetoRateio = dadosTabelaNormal.find(p => p.projeto === NOME_RATEIO);

  // Se o projeto não existir nos dados, retorna sem alteração
  if (!projetoRateio || projetoRateio.custoOperacional === 0) {
    return dadosTabelaNormal.filter(p => p.projeto !== NOME_RATEIO);
  }

  const custoParaRatear = projetoRateio.custoOperacional;
  const demais = dadosTabelaNormal.filter(p => p.projeto !== NOME_RATEIO);

  // Base de rateio: soma do faturamento líquido dos demais projetos
  const totalFatLiq = demais.reduce((sum, p) => sum + p.faturamentoLiquido, 0);

  const calcularPercentual = (valor, base) =>
    base > 0 ? ((valor / base) * 100).toFixed(2) : '0.00';

  return demais.map(p => {
    // Proporção do projeto em relação ao total; divisão igualitária como fallback
    const proporcao = totalFatLiq > 0
      ? p.faturamentoLiquido / totalFatLiq
      : 1 / demais.length;

    const custoRateado    = custoParaRatear * proporcao;
    const novoCustoOp     = p.custoOperacional + custoRateado;
    const novaMargemBruta = p.faturamentoLiquido - p.custoMaoDeObra - novoCustoOp;

    return {
      ...p,
      custoOperacional:      novoCustoOp,
      percentualCustoOp:     calcularPercentual(novoCustoOp, p.faturamentoLiquido),
      margemBrutaReal:       novaMargemBruta,
      percentualMargemBruta: calcularPercentual(novaMargemBruta, p.faturamentoLiquido),
    };
  });
})();
// ────────────────────────────────────────────────────────────────────────────

let dadosTabela = [];

    if (is2025) {
      dadosTabela = dadosTabela2025;
    } else {
      dadosTabela = dadosTabelaNormalComRateio;
    }


  // Função para ordenar os dados
  const handleOrdenar = (campo) => {
    setOrdenacao(prev => ({
      campo,
      direcao: prev.campo === campo && prev.direcao === 'asc' ? 'desc' : 'asc'
    }));
  };
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  // Aplicar ordenação aos dados
  const dadosOrdenados = [...dadosTabela].sort((a, b) => {
    if (!ordenacao.campo) return 0;

    let valorA = a[ordenacao.campo];
    let valorB = b[ordenacao.campo];

    // Trata null / undefined
    if (valorA == null) valorA = '';
    if (valorB == null) valorB = '';

    // Se pelo menos um for string, compara como texto
    if (typeof valorA === 'string' || typeof valorB === 'string') {
      valorA = String(valorA).toLowerCase();
      valorB = String(valorB).toLowerCase();

      return ordenacao.direcao === 'asc'
        ? valorA.localeCompare(valorB)
        : valorB.localeCompare(valorA);
    }

    // Comparação numérica
    valorA = Number(valorA) || 0;
    valorB = Number(valorB) || 0;

    return ordenacao.direcao === 'asc'
      ? valorA - valorB
      : valorB - valorA;
  });
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };
  const top10Projetos = [...dadosTabela]
    .map(item => ({
      ...item,
      margem: parseBRL(item.margemBrutaReal.toFixed(2))
    }))
    .filter(item => item.margem > 0)
    .sort((a, b) => b.margem - a.margem)
    .slice(0, 10);

  const cores = ['#C41E5C', '#E91E63', '#6B4C8A', '#F9D45C', '#4A90E2', '#50C878', '#FF6B6B', '#4ECDC4'];

  const pieData = top10Projetos.map((item, idx) => ({
    name: item.projeto,
    value: item.margem,
    color: cores[idx % cores.length]
  }));

  // Componente para ícone de ordenação
  const IconeOrdenacao = ({ campo }) => {
    if (ordenacao.campo !== campo) {
      return <ArrowUpDown size={14} className="text-gray-400" />;
    }
    return ordenacao.direcao === 'asc' 
      ? <ArrowUp size={14} className="text-indigo-600" />
      : <ArrowDown size={14} className="text-indigo-600" />;
  };
  const toggleDetalhe = (projeto) => {
    setLinhasExpandidas(prev => ({
      ...prev,
      [projeto]: !prev[projeto]
    }));
  };
  const detalhesPorProjeto = (projeto) => {
    return dadosFiltrados.filter(item => item.projeto === projeto);
  };
  const navigate = useNavigate();

  const limparFiltros = () => {
    setFilters({
    projeto: [],
    prestador: [],
    gerente: [],
    dataDre: [],
    anoDre: [],
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <span className="text-2xl font-bold">YOUX</span>
          <span className="text-xl font-light">GROUP</span>
        </div>

          <button
            onClick={() => {
              navigate('/inicio');
            }}
            className="flex items-center gap-2 px-4 py-2 hover:bg-white/10 rounded-lg text-sm font-bold"
          >
            Menu Principal
          </button>   
          
      </header>

      <div className="p-6">
        {/* Título */}
        
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-semibold">
                  Margem Bruta
              </h1>

              <div className="flex gap-2">

                  <button
                  onClick={carregarDadosGoogleSheets}
                  className="px-4 py-2 bg-indigo-600 text-white rounded-lg shadow-sm hover:bg-indigo-700 transition-colors text-sm"
                  >
                  Atualizar Dados
                  </button>
              </div>
            </div>


        {/* Mensagem de Erro */}
        {error && (
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
            <div className="flex">
              <AlertCircle className="text-yellow-400 mr-3" size={20} />
              <div>
                <p className="text-sm text-yellow-700">
                  <strong>Atenção:</strong> {error}
                </p>
                <p className="text-xs text-yellow-600 mt-1">
                  Verifique se o servidor Flask está rodando em http://localhost:8000
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Indicadores de Dados Carregados */}
        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-4">
            <div className="text-xs text-gray-600 mb-1">NFe Carregadas</div>
            <div className="text-2xl font-bold text-indigo-600">{dadosOriginais.length}</div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4">
            <div className="text-xs text-gray-600 mb-1">Lançamentos Carregados</div>
            <div className="text-2xl font-bold text-purple-600">{dadosLancamentos.length}</div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-4">
            <div className="text-xs text-gray-600 mb-1">Projetos Filtrados</div>
            <div className="text-2xl font-bold text-pink-600">{dadosTabela.length}</div>
          </div>
        </div>

        {/* Filtros */}
        
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-xs text-gray-600 mb-1">Projeto</label>
              <MultiSelect
                options={projetosOptions}
                placeholder="Projetos"
                value={filters.projeto}
                onChange={(v) => setFilters(f => ({ ...f, projeto: v }))}
              />

            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">Prestador de Serviço</label>
              <MultiSelect
                options={prestadoresOptions}
                placeholder="Prestadores"
                value={filters.prestador}
                onChange={(v) => setFilters(f => ({ ...f, prestador: v }))}
              />

            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">Gerente de Projetos</label>
                <MultiSelect
                  options={gerentesOptions}
                  placeholder="Gerentes"
                  value={filters.gerente}
                  onChange={(v) => setFilters(f => ({ ...f, gerente: v }))}
                />

            </div>
            <div>
              <label className="block text-xs text-gray-600 mb-1">Mês DRE</label>
              <MultiSelect
                options={mesesOptions}
                placeholder="Meses"
                value={filters.dataDre}
                onChange={(v) => setFilters(f => ({ ...f, dataDre: v }))}
              />

            </div>
            <div>
            <label className="block text-xs text-gray-600 mb-1">Ano</label>
              <MultiSelect
                options={anosOptions}
                placeholder="Anos"
                value={filters.anoDre}
                onChange={(v) => setFilters(f => ({ ...f, anoDre: v }))}
              />

            </div>
          </div>
          <div className="flex items-center justify-between mb-3">
            <button
              onClick={limparFiltros}
              className="text-sm text-pink-600 hover:text-pink-700 font-medium"
            >
              Limpar Filtros
            </button>
          </div>
        </div>

        {/* Tabela com Ordenação */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          {loading ? (
            <div className="text-center py-8">
              <RefreshCw className="animate-spin mx-auto mb-2" size={32} />
              <p className="text-gray-600">Carregando dados...</p>
            </div>
          ) : dadosTabela.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-600">Nenhum projeto encontrado com os filtros selecionados</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b">
                    <th 
                      className="text-left py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('projeto')}
                    >
                      <div className="flex items-center space-x-1">
                        <span>Projeto</span>
                        <IconeOrdenacao campo="projeto" />
                      </div>
                    </th>
                    <th 
                      className="text-left py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('gerente')}
                    >
                      <div className="flex items-center space-x-1">
                        <span>Gerente</span>
                        <IconeOrdenacao campo="gerente" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('valorBruto')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Faturamento Bruto</span>
                        <IconeOrdenacao campo="valorBruto" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('faturamentoLiquido')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Faturamento Líquido</span>
                        <IconeOrdenacao campo="faturamentoLiquido" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold bg-blue-50 cursor-pointer hover:bg-blue-100 select-none"
                      onClick={() => handleOrdenar('custoOperacional')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Custo Operacional</span>
                        <IconeOrdenacao campo="custoOperacional" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold bg-blue-50 cursor-pointer hover:bg-blue-100 select-none"
                      onClick={() => handleOrdenar('percentualCustoOp')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>% Custo Op.</span>
                        <IconeOrdenacao campo="percentualCustoOp" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold bg-blue-50 cursor-pointer hover:bg-blue-100 select-none"
                      onClick={() => handleOrdenar('custoMaoDeObra')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Mão de Obra</span>
                        <IconeOrdenacao campo="custoMaoDeObra" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold bg-blue-50 cursor-pointer hover:bg-blue-100 select-none"
                      onClick={() => handleOrdenar('custoMaoDeObra')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Mão de Obra %</span>
                        <IconeOrdenacao campo="custoMaoDeObra" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('margemBrutaReal')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>Margem Bruta Real</span>
                        <IconeOrdenacao campo="margemBrutaReal" />
                      </div>
                    </th>
                    <th 
                      className="text-right py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                      onClick={() => handleOrdenar('percentualMargemBruta')}
                    >
                      <div className="flex items-center justify-end space-x-1">
                        <span>% Margem Bruta</span>
                        <IconeOrdenacao campo="percentualMargemBruta" />
                      </div>
                    </th>
                    {!is2025 && (
                      <th 
                        className="text-right py-3 px-2 text-gray-700 font-semibold cursor-pointer hover:bg-gray-50 select-none"
                        onClick={() => handleOrdenar('margemProjetada')}
                      >
                        <div className="flex items-center justify-end space-x-1">
                          <span>% Margem Projetada</span>
                          <IconeOrdenacao campo="margemProjetada" />
                        </div>
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {dadosOrdenados.map((row, idx) => {
                    const aberto = linhasExpandidas[row.projeto];

                    return (
                      <React.Fragment key={idx}>
                        {/* Linha principal */}
                        <tr className="border-b hover:bg-gray-50">
                          <td className="py-3 px-2 font-semibold">{row.projeto}</td>
                          <td className="py-3 px-2">{row.gerente}</td>
                          <td className="text-right py-3 px-2">{formatCurrency(row.valorBruto)}</td>
                          <td className="text-right py-3 px-2">{formatCurrency(row.faturamentoLiquido)}</td>
                          <td className="text-right py-3 px-2 bg-blue-50">{formatCurrency(row.custoOperacional)}</td>
                          <td className="text-right py-3 px-2 bg-blue-50">{row.percentualCustoOp}%</td>
                          <td className="text-right py-3 px-2 bg-blue-50">{formatCurrency(row.custoMaoDeObra)}</td>
                          <td className="text-right py-3 px-2 bg-blue-50">{row.percentualMaoDeObra}%</td>
                          <td className="text-right py-3 px-2">{formatCurrency(row.margemBrutaReal)}</td>
                          <td className="text-right py-3 px-2 text-green-600">{row.percentualMargemBruta}%</td>
                          <td className="text-right py-3 px-2 text-green-600">{row.margemProjetada}</td>

                          <td className="py-3 px-2">
                            <button
                              onClick={() => toggleDetalhe(row.projeto)}
                              className="text-indigo-600 hover:text-indigo-800"
                            >
                              {aberto ? '▼' : '▶'}
                            </button>
                          </td>
                        </tr>

                        {/* Detalhamento */}
                        {aberto && (
                          <tr className="bg-gray-50">
                            <td colSpan={11} className="px-6 py-4">
                              <table className="w-full text-xs border">
                                <thead>
                                  <tr className="bg-gray-100">
                                    <th className="text-left px-2 py-1">Prestador</th>
                                    <th className="text-left px-2 py-1">Gerente</th>
                                    <th className="text-right px-2 py-1">Valor Bruto</th>
                                    <th className="text-right px-2 py-1">Fat. Líquido</th>
                                    <th className="text-center px-2 py-1">Mês/Ano</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {detalhesPorProjeto(row.projeto).map((det, i) => (
                                    <tr key={i} className="border-t">
                                      <td className="px-2 py-1">{det.prestador}</td>
                                      <td className="px-2 py-1">{det.gerente}</td>
                                      <td className="text-right px-2 py-1">{formatCurrency(det.valorBruto)}</td>
                                      <td className="text-right px-2 py-1">{formatCurrency(det.faturamentoLiquido)}</td>
                                      <td className="text-center px-2 py-1">
                                        {det.dataDre}/{det.anoDre}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="border-t-2 border-gray-300 bg-gray-100 font-bold">
                    <td className="py-3 px-2" colSpan={2}>TOTAL GERAL</td>
                    <td className="text-right py-3 px-2">
                      {formatCurrency(dadosOrdenados.reduce((acc, row) => acc + row.valorBruto, 0))}
                    </td>
                    <td className="text-right py-3 px-2">
                      {formatCurrency(dadosOrdenados.reduce((acc, row) => acc + row.faturamentoLiquido, 0))}
                    </td>
                    <td className="text-right py-3 px-2 bg-blue-100">
                      {formatCurrency(dadosOrdenados.reduce((acc, row) => acc + row.custoOperacional, 0))}
                    </td>
                    <td className="text-right py-3 px-2 bg-blue-100">
                      {(() => {
                        const totalFatLiq = dadosOrdenados.reduce((acc, row) => acc + row.faturamentoLiquido, 0);
                        const totalCustoOp = dadosOrdenados.reduce((acc, row) => acc + row.custoOperacional, 0);
                        return totalFatLiq > 0 ? ((totalCustoOp / totalFatLiq) * 100).toFixed(2) : '0.00';
                      })()}%
                    </td>
                    <td className="text-right py-3 px-2 bg-blue-100">
                      {formatCurrency(dadosOrdenados.reduce((acc, row) => acc + row.custoMaoDeObra, 0))}
                    </td>
                    <td className="text-right py-3 px-2 bg-blue-100">
                      {(() => {
                        const totalFatLiq = dadosOrdenados.reduce((acc, row) => acc + row.faturamentoLiquido, 0);
                        const totalMaoObra = dadosOrdenados.reduce((acc, row) => acc + row.custoMaoDeObra, 0);
                        return totalFatLiq > 0 ? ((totalMaoObra / totalFatLiq) * 100).toFixed(2) : '0.00';
                      })()}%
                    </td>
                    <td className="text-right py-3 px-2">
                      {formatCurrency(dadosOrdenados.reduce((acc, row) => acc + row.margemBrutaReal, 0))}
                    </td>
                    <td className="text-right py-3 px-2 text-green-700">
                      {(() => {
                        const totalFatLiq = dadosOrdenados.reduce((acc, row) => acc + row.faturamentoLiquido, 0);
                        const totalMargem = dadosOrdenados.reduce((acc, row) => acc + row.margemBrutaReal, 0);
                        return totalFatLiq > 0 ? ((totalMargem / totalFatLiq) * 100).toFixed(2) : '0.00';
                      })()}%
                    </td>
                    <td className="py-3 px-2"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;